export const UserRoles = {
  admin: 'Client Admin',
  associate: 'Associate',
  owner: 'Owner',
  client: 'Client',
  superuser: 'Super User',
  consultant: 'Consultant',
};
